import Icon       from "_components/atoms/icon";
import Typography from "_components/atoms/typography";

import useStyles from "./styles";

const component = () => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<div className = { classes.container }>
			<Icon className = { classes.icon }
				name           = "emptyFeed"
			/>

			<Typography title = "Nothing to Show" />
		</div>
	);
};

export default component;
